import React from 'react';
import { Formik, Form } from 'formik';
import styles from './target.module.scss';
import InputField from 'shared/components/InputField';
import { getTargetFields } from './constants';
import { SbtiResponse } from 'models/Sbti/sbti.model';
import { CompanyDashboardProps } from 'views/CompanyDashboard/constants';

interface DetailsProps {
  data?: SbtiResponse;
  index: number;
}

const Details: React.FC<DetailsProps> = ({ data, index }) => {
  const target = data && data?.sbtiTarget && data?.sbtiTarget[index];
  const fields = target ? getTargetFields(target) : [];

  return (
    <Formik initialValues={{}} onSubmit={() => {}}>
      <Form>
        <div className={styles.questionsArea}>
          <div className={styles.fieldContainer}>
            {fields.map(
              field =>
                field && (
                  <div
                    className={
                      field.name === CompanyDashboardProps.NOTES
                        ? styles.inputAreaContainer
                        : styles.inputContainer
                    }
                    key={field.name}>
                    <label>{field.label}</label>
                    <InputField
                      name={field.name}
                      textarea={field.name === CompanyDashboardProps.NOTES}
                      placeholderstring=""
                      value={field.value}
                      disabled
                    />
                  </div>
                )
            )}
          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default Details;
